export function getAsset3DModelImageURL(
  type: string,
  geckoAssetsUrl: string
): string | undefined {
  switch (type) {
    case 'vertical_tank':
      return geckoAssetsUrl + '/rich_asset_model/tank.png'
    case 'horizontal_tank':
    case 'pressure_vessel':
      return geckoAssetsUrl + '/rich_asset_model/pressure vessel.png'
    case 'piping':
      return geckoAssetsUrl + '/rich_asset_model/pipeline.png'
    case 'legacy_boiler':
      return geckoAssetsUrl + '/rich_asset_model/boiler.png'
    case 'ship':
      return geckoAssetsUrl + '/rich_asset_model/boat.png'
    case 'missile_silo':
      return geckoAssetsUrl + '/rich_asset_model/silo.png'
    case 'nuclear_containment_dome':
      return geckoAssetsUrl + '/rich_asset_model/containment dome.png'

    case 'machined_forging':
      return geckoAssetsUrl + '/rich_asset_model/machined forging.png'
    case 'hood':
      return geckoAssetsUrl + '/rich_asset_model/hood.png'
  }
  return undefined
}
